import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import dayjs from "dayjs";
import { useAtomValue } from "jotai";

export type Formats = {
  dateformat: string;
  locale: string;
};

function useFormats(): Formats & {
  extra: Omit<Formats, "extra">;
  currentDate: string;
} {
  const dateformat =
    useAtomValue(userConfigAtom).visualConfig.config?.date_format ??
    "YYYY-MM-DD";

  const locale =
    useAtomValue(userConfigAtom).visualConfig.config?.locale ?? "en-US";
  const currentDate = dayjs()?.format(dateformat);
  return { dateformat, locale, extra: { dateformat, locale }, currentDate };
}

export { useFormats };
